import { BinaryDependencyConfidence } from '../../../../shared/binaryDependencyConfidence';
import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';

const FILTER_OPTIONS = [
  { key: BinaryDependencyConfidence.High, label: 'High' },
  { key: BinaryDependencyConfidence.Medium, label: 'Medium' },
  { key: BinaryDependencyConfidence.Low, label: 'Low' },
  { key: BinaryDependencyConfidence.Unknown, label: 'Unknown' },
];

export type ConfidenceIssueFilterProps = {
  selectedOptions?: string[];
  onSelect: (key: string, selected: boolean) => void;
};

const ConfidenceIssueFilter = ({ selectedOptions, onSelect }: ConfidenceIssueFilterProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="Dependency Confidence"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-confidence-filters"
    />
  </FilterPanel>;

export default ConfidenceIssueFilter;
